import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  CatalogsLoadAction,
  CatalogsLoadedFailAction,
  CatalogsLoadedSuccessAction,
  LOAD_CATALOGS,
} from '../actions/catalogs.actions';
import { CatalogsResponse, CatalogsService } from '@cemex-core/cmx-api';

@Injectable()
export class CatalogsEffects {
  loadCatalog$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<CatalogsLoadAction>(LOAD_CATALOGS),
      switchMap((action) => {
        return this.catalogsService.getCatalogs(action.payload).pipe(
          map((response: CatalogsResponse) => new CatalogsLoadedSuccessAction(response)),
          catchError((error) => of(new CatalogsLoadedFailAction(error))),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private catalogsService: CatalogsService,
  ) {}
}
